import React from 'react';
import * as immutable from 'object-path-immutable';
import CCEvents, { EventNames } from '@companycam/companycam-events';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { useMutation } from '@apollo/client';

import GET_TASK_LIST_TEMPLATES from '../gql/getTaskListTemplates.graphql';
import TASK_LIST_TEMPLATE_DELETE from '../gql/taskListTemplateDelete.graphql';
import { TEMPLATES_PER_PAGE } from './constants';
import toast from 'helpers/toast';

const useDeleteTemplate = ({ onSuccess } = {}) => {
  const showErrorToast = (errorMsg) => {
    toast.error(
      errorMsg || (
        <FormattedMessage
          id="Projects.taskList.templates.error.delete"
          defaultMessage="There was an error deleting the template"
          description="Default error message for deleting template"
        />
      ),
    );
  };

  const [deleteTemplate, { loading }] = useMutation(TASK_LIST_TEMPLATE_DELETE, {
    onCompleted: async ({ taskListTemplateDelete: res }) => {
      if (!res.errors.length) {
        CCEvents.logEvent(EventNames.TASK_LIST_TEMPLATES.DELETE_TEMPLATE);
        toast.success(
          <FormattedMessage
            id="Projects.taskList.templates.success.delete"
            defaultMessage="The template was succesfully deleted"
            description="Success message for deleting template"
          />,
        );
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    onError: showErrorToast,

    update: (
      cache,
      {
        data: {
          taskListTemplateDelete: { deletedId, errors },
        },
      },
    ) => {
      if (!deletedId || errors.length) {
        showErrorToast(errors, errors[0].message);
        return;
      }

      const cachedData = cache.readQuery({
        query: GET_TASK_LIST_TEMPLATES,
        variables: {
          first: TEMPLATES_PER_PAGE,
          includePartnerTemplates: false,
        },
      });

      const nodes = get(
        cachedData,
        'viewer.company.taskListTemplates.nodes',
        [],
      );

      const updatedNodes = nodes.filter((node) => node.id !== deletedId);

      cache.writeQuery({
        query: GET_TASK_LIST_TEMPLATES,
        variables: {
          first: TEMPLATES_PER_PAGE,
          includePartnerTemplates: false,
        },
        data: immutable.set(
          cachedData,
          'viewer.company.taskListTemplates.nodes',
          updatedNodes,
        ),
      });
    },
  });

  return {
    deleteTemplate,
    loading,
  };
};

export default useDeleteTemplate;
